export const getEventModelName = (eventData: { eventType: string | null; relation: string }) => {
    if (!eventData) return null;
    const { eventType, relation } = eventData;
    return `${relation ?? ""}${eventType ?? ""}`;
};
